import PropTypes from 'prop-types';

import Image from './image.component';

const Hover = (props) => {
   
    const { imgSrc, imgAlt } = props;

    const renderHoverEffect = () => {
        return (
            <div className='hover-cut-container'>
                <div className='hover-background-div'/>
                <div className='hover-slice-container'>                
                    <Image className='hover-image' src={imgSrc} alt={imgAlt} isOldImage />
                </div>
            </div>
        );
    };

    return (
        <div className='hover-container'>
            {renderHoverEffect()}
        </div>
    );
};

export default Hover;

Hover.propTypes = {
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
};


